import React, { FC } from 'react'
import { AnimationProps } from './Animation.d'
import { LottieProps } from '@toasttab/shared/src/components/atoms/LottiePlayer/LottiePlayer.d'
const LottiePlayer: FC<LottieProps> =
  typeof window !== 'undefined' || process.env.NODE_ENV === 'test'
    ? require('@toasttab/shared/src/components/atoms/LottiePlayer/LottiePlayer')
        .default
    : () => null

const Animation = ({
  autoPlay,
  cssClasses,
  loop,
  hover,
  image,
  muted,
  previewImage
}: AnimationProps) => {
  const { optimizedImages, title, url } = image[0]
  // Get the extension from the url if no extension value is provided
  const extension = image[0].extension || url.split('.').pop()
  return (
    <>
      {extension === 'json' ? (
        <LottiePlayer
          classes={cssClasses}
          lottieFile={url}
          hover={hover}
          autoPlay={autoPlay}
          loop={loop}
          previewImage={previewImage}
        />
      ) : ['mp4', 'webm'].includes(extension) ? (
        <video
          muted={muted}
          autoPlay={autoPlay}
          loop={loop}
          className={`w-full object-cover ${cssClasses}`}
          data-testid='Animation-video'
        >
          <source src={url} type={`video/${extension}`} />
          {extension === 'webm' && (
            <source src={url.replace('.webm', '.mp4')} type='video/mp4' />
          )}
          Your browser does not support the video tag.
        </video>
      ) : (
        <>
          {optimizedImages?.optimizedImageUrls?.length > 0 ? (
            <picture
              className={`block ${cssClasses}`}
              data-testid='Animation-picture'
            >
              <source srcSet={optimizedImages.srcAvif} type='image/webp' />
              <img
                alt={title}
                className='object-cover'
                src={optimizedImages.src}
              />
            </picture>
          ) : (
            <img
              alt={title}
              className={`block object-cover ${cssClasses}`}
              data-testid='Animation-img'
              src={url}
            />
          )}
        </>
      )}
    </>
  )
}

export default Animation
